<template>
  <div class="checkout-section cart-summary">
    <div class="container pd-sm-0 mt-3">
      <h1 class="header-title">ตะกร้าของคุณ</h1>

      <undo-remove v-for="item in removedProducts" :key="sku(item)"
                   :product="item.product"
                   :attributes="item.attributes"
                   :quantity="item.quantity"
                   v-on:undo="onUndo"></undo-remove>

      <div class="with-sidebar">
        <div class="content">
          <div class="product-summary">
            <div class="block-secondary block">
              <cart-summary v-on:itemRemoved="itemRemoved"></cart-summary>

              <div v-if="$utils.isCartEmpty()">
                คุณยังไม่ได้เลือกรายการบริจาค
                <router-link :to="{ name: 'products_list' }">เลือกดูรายการของเรา</router-link>
              </div>

              <div class="product__action" v-if="buyMoreButton">
                <a class="btn btn--white" href="#" @click.prevent="gotoProductList()">เลือกรายการเพิ่ม</a>
              </div>
            </div>

            <br>
          </div>

          <delivery-selector class="show-sm"></delivery-selector>

        </div>

        <div class="sidebar-container hide-sm">
          <div class="sidebar" v-sticky="{triggerTop: 70, top:70, triggerBottom: 70, bottom: 70}">
            <div class="block block-secondary">
              <h3 class="sidebar__title">รายการในตะกร้า <small>({{ $utils.getCartItemCount() }} รายการ)</small></h3>
              <div class="summary__row--lg">
                <span class="summary__label">รวม</span>
                <span class="summary__value">{{ $utils.getCartGrandTotalPrice() | comma }}  ฿</span>
              </div>

              <delivery-selector></delivery-selector>

              <a class="btn btn--purple ma-0" href="#" @click.prevent="gotoCheckout()">ชำระเงิน</a>
            </div>
          </div>
          <div class="sidebar sidebar-ghost"></div>
        </div>
      </div>



    </div>

    <div class="block-primary block show-sm" v-if="checkoutButton">
      <a class="btn btn--purple ma-0" href="#" @click.prevent="gotoCheckout()">ชำระเงิน</a>
    </div>
  </div>
</template>

<script>
import ProductListItem from './ProductListItem.vue'
import CartSummary from './CartSummary.vue'
import UndoRemove from './UndoRemove.vue'
import DeliverySelector from './DeliverySelector'

export default {
  components: {
    DeliverySelector,
    UndoRemove,
    CartSummary,
    ProductListItem
  },
  name: 'cart',
  props: {
    checkoutButton: {
      type: Boolean,
      required: false,
      default: true
    },
    buyMoreButton: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      removedProducts: [],
      didChooseShippingMethod: false
    }
  },
  created () {
    this.$store.dispatch('syncProducts', true)
  },
  computed: {
  },
  methods: {
    sku (item) {
      return this.$utils.getProductConfigSku(item.product, item.attributes)
    },
    gotoProductList () {
      this.$router.push({name: 'products_list'})
    },
    gotoCheckout () {
      if (this.totalPrice === 0) {
        this.$modal.show({
          title: 'มีบางอย่างไม่ถูกต้อง',
          text: 'จำนวนรายการไม่สามารถเป็นศูนย์ได้ กรุณาเลือกรายการใหม่หรือเพิ่มจำนวนก่อนทำรายการ'
        })
        return
      }
      this.$router.push('/checkout')
    },
    itemRemoved (product, attributes, quantity) {
      this.removedProducts.push({
        product: product,
        attributes: attributes,
        quantity: quantity
      })
    },
    onUndo (product, attributes) {
      this.removedProducts = this.removedProducts.filter(item => {
        return this.sku(item) !== this.sku({ product, attributes })
      })
    },
    setOfflineShipping (value) {
      this.didChooseShippingMethod = true
      this.$utils.setOfflineShipping(value)
    }
  }
}
</script>

<style scoped lang="scss">
.cart-summary {
  .product {
    &__action {
      margin: 15px 0 0 auto;
      display: flex;
      width: 50%;
      .btn { margin: 0; }
    }
  }
}
@media screen and (max-width: 768px) {
  .cart-summary {
    .product {
      &__action {
        width: 100%;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Cart.vue?6da6db0e